import { useState, useEffect } from "react";
import ShimmerLoader from "../../components/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchdepositrequest, fetchbankList } from "../wallet/walletSlice";
import { selectCurrentUser } from "../auth/authSlice";
import Moment from "moment";
import { format, parseISO } from "date-fns";
import { Funnel } from "lucide-react";
import CurFt from "../../components/CurFt";
import Pagination from "../../components/Pagination";
import useDocumentTitle from "../../hooks/useDocumentTitle";

export default function Depositrequest() {
  useDocumentTitle("Deposit Request");
  const dispatch = useDispatch();
  const { depositrequestStatus, depositrequestData } = useSelector((state) => state.wallet);
  const perPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [BookingHistory, SetWalletHistory] = useState([]);
  const [BankAccount, SetBankAccount] = useState([]);

  const [available_credit, setavailable_credit] = useState(0);
  const [total_credit_limit, settotal_credit_limit] = useState(0);
  const [totalOutStanding, settotalOutStanding] = useState(0);

  const user = useSelector(selectCurrentUser);
  const [showFilters, setShowFilters] = useState(false);
  const [FilterData, setFilterData] = useState({
    filterType: "Flight",
    referenceno: null,
    FromDate: null,
    ToDate: null,
    customer_id: user?.UserData?.id,
  });
  const fetchdepositrequestS = async () => {
    dispatch(fetchdepositrequest({ FilterData, perPage, currentPage }));
  };
  const fetchbankLists = async () => {
    const response = await dispatch(fetchbankList({ FilterData })).unwrap();
    SetBankAccount(response?.data?.data || []);
  };
  useEffect(() => {
    fetchdepositrequestS();
    fetchbankLists();

  }, [FilterData, currentPage]);

  useEffect(() => {
    const data = depositrequestData;
    setavailable_credit(data?.sums?.grand_total || 0);
    settotal_credit_limit(data?.sums?.pending || 0);
    settotalOutStanding(data?.sums?.approved || 0);
    // settotalProfit(data.totalProfit);
    SetWalletHistory(data?.data?.data || data);
    setTotalPages(data?.data?.last_page);
  }, [depositrequestStatus, depositrequestData]);
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleFilterChange = (field, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  return (
    <div className="bg-gray-100 text-gray-800 relative min-h-screen">
      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4 space-y-6">
        <div className="bg-white shadow-md rounded-lg p-4 mt-4">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h3 className="font-semibold">Deposit Request</h3>
            <span className="font-semibold text-blue-500 flex items-center gap-1">
              <div className="relative text-blue-500 text-left">
                TOTAL REQUEST
                <br />
                <span className="text-1">
                  <CurFt currency={"INR"} price={available_credit} />
                </span>
              </div>
            </span>
            <span className="font-semibold flex items-center gap-1">
              <div className="relative text-gray-500 text-left">
                TOTAL PENDING
                <br />
                <span className="text-1">
                  <CurFt currency={"INR"} price={total_credit_limit} />
                </span>
              </div>
            </span>
            <span className="font-semibold flex items-center gap-1">
              <div className="relative text-orange-500 text-left">
                TOTAL APPROVED
                <br />
                <span className="text-1">
                  <CurFt currency={"INR"} price={totalOutStanding} />
                </span>
              </div>
            </span>
            <span className="font-semibold text-blue-500 flex items-center gap-1">
              <div className="relative inline-block text-left">
                <button
                  onClick={toggleFilters}
                  className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 ${showFilters ? "bg-blue-600 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"
                    }`}
                >
                  <Funnel />
                </button>
              </div>
            </span>
          </div>
        </div>
        {showFilters && (
          <div className="bg-white shadow-md rounded-lg p-6 mt-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              {/* First Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Reference Number</label>
                  <input
                    type="text"
                    value={FilterData.referenceno}
                    onChange={(e) => handleFilterChange("referenceno", e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    placeholder="Reference Number"
                  />
                </div>
              </div>

              {/* Second Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking From Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={FilterData.FromDate ? new Date(FilterData.FromDate).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("FromDate", formattedDate);
                      }}
                      max={new Date().toISOString().split("T")[0]}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.FromDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("FromDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Third Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Booking To Date</label>
                  <div className="relative">
                    <input
                      type="date"
                      value={FilterData.ToDate ? new Date(FilterData.ToDate).toISOString().split("T")[0] : ""}
                      onChange={(e) => {
                        const date = e.target.value;
                        const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                        handleFilterChange("ToDate", formattedDate);
                      }}
                      // max={new Date().toISOString().split("T")[0]}
                      className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {FilterData.ToDate && (
                      <button
                        type="button"
                        onClick={() => handleFilterChange("ToDate", null)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Empty columns for spacing */}
              <div className="space-y-4"></div>
              <div className="space-y-4"></div>

              {/* Close Button in the last column */}
              <div className="space-y-4">
                <div className="pt-6">
                  <button
                    onClick={() => setShowFilters(false)}
                    className="w-full bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                  >
                    Close Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">
          <div className="overflow-x-auto">
            <table className="min-w-full border  text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 border text-left">No.</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Trx Date
                  </th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Reference No
                  </th>
                  <th className="px-3 py-2 border text-left">Payment Mode</th>
                  <th className="px-3 py-2 border text-left">Remarks</th>

                  <th className="px-3 py-2 border text-right" nowrap="true">
                    Amount
                  </th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {depositrequestStatus === "loading" ? (
                  <>
                    <tr className="border-b">
                      <td className="px-3 py-2 border" colSpan={12}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {BookingHistory?.length > 0 ? (
                      BookingHistory.map((item, key) => (
                        <tr className="border-b" key={key}>
                          <td className="px-3 py-2 border">{key + 1}</td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {format(parseISO(item.created_at), "dd MMM, yyyy")}
                            <br />
                            {Moment(item.created_at).format("h:mm A")}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.referenceno}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.PaymentMode}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.remarks}
                          </td>
                          <td className="px-3 py-2 border text-right" nowrap="true">
                            {item.status == "pending" ? (
                              <span className="text-gray-600">
                                <CurFt currency={"INR"} price={item.amount} />
                              </span>
                            ) : (
                              <span className="text-orange-500">
                                <CurFt currency={"INR"} price={item.amount} />
                              </span>
                            )}
                          </td>
                          <td className="px-3 py-2 border text-left">{item.status}</td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr className="border-b">
                          <td colSpan={12} className="px-3 py-2 border">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </tbody>
            </table>
            <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </div>
        <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">
          <h3 className="font-semibold">Bank Account</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full border  text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 border text-left">No.</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Account Name
                  </th>
                  <th className="px-3 py-2 border text-left" nowrap="true">
                    Account No
                  </th>
                  <th className="px-3 py-2 border text-left">IFSC Code</th>
                  <th className="px-3 py-2 border text-left">Bank Name</th>
                  <th className="px-3 py-2 border text-left">Branch</th>
                  <th className="px-3 py-2 border text-left">Type</th>
                </tr>
              </thead>
              <tbody>
                {depositrequestStatus === "loading" ? (
                  <>
                    <tr className="border-b">
                      <td className="px-3 py-2 border" colSpan={12}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {BankAccount?.length > 0 ? (
                      BankAccount.map((item, key) => (
                        <tr className="border-b" key={key}>
                          <td className="px-3 py-2 border">{key + 1}</td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.Account_Name}

                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.Account_No}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.IFSC_Code}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.Bank_Name}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.Branch}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.Account_Type}
                          </td>

                        </tr>
                      ))
                    ) : (
                      <>
                        <tr className="border-b">
                          <td colSpan={12} className="px-3 py-2 border">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}
